<div
  [ngClass]="{
    'tile--with-logo': announcementDetails?.hasLogo,
    'tile-jobseeker': !isPublicView,
    'tile': isPublicView
  }"
>
  <!-- Favourite + share moved to the top-right corner of the tile (HR-3762). -->
  <div class="corner-actions" *ngIf="isPublicView" [ngClass]="{
      'corner-actions--with-logo': announcementDetails?.hasLogo
    }">
    <div class="share-wrapper">
      <button
        class="corner-actions__btn"
        (click)="onToggleShare()"
        [attr.aria-label]="'label.ShareAnnouncement' | translate"
      >
        <svg-icon
          [src]="
            !isShareButtonClicked
              ? `/assets/icons/share-${providerWebsiteId}.svg`
              : `/assets/icons/share-${providerWebsiteId}-filled.svg`
          "
          class="corner-actions__icon-wrapper"
          [svgClass]="'corner-actions__icon'"
        ></svg-icon>
      </button>
      <div
        class="sharing-providers sharing-providers--corner"
        *ngIf="isShareButtonClicked"
        @listAnimation
      >
        <div class="sharing-providers__copy-link" (click)="onCopyLink()">
          <svg-icon src="assets/icons/share-copy-link.svg"></svg-icon>
          <span
            [@copiedAnimation]
            class="copied-text"
            *ngIf="isAnnouncementLinkCopied"
            >{{ 'label.LinkCopied' | translate }}</span
          >
        </div>
        <div
          class="sharing-providers__facebook"
          (click)="onSocialShare(socialMediaShareLinks.facebookShareUrl)"
        >
          <svg-icon src="assets/icons/share-facebook.svg"></svg-icon>
        </div>
        <div
          class="sharing-providers__linkedin"
          (click)="onSocialShare(socialMediaShareLinks.linkedInShareUrl)"
        >
          <svg-icon src="assets/icons/share-linkedin.svg"></svg-icon>
        </div>
        <div
          class="sharing-providers__x"
          (click)="onSocialShare(socialMediaShareLinks.xShareUrl)"
        >
          <svg-icon src="assets/icons/share-x.svg"></svg-icon>
        </div>
        <div
          class="sharing-providers__gmail"
          (click)="onSocialShare(socialMediaShareLinks.mailShareUrl)"
        >
          <svg-icon src="assets/icons/share-gmail.svg"></svg-icon>
        </div>
      </div>
    </div>
    <button
      class="corner-actions__btn"
      (click)="onToggleFavorite()"
      [attr.aria-label]="
        (isFavorite ? 'label.RemoveFromFavorites' : 'label.AddToFavorites')
          | translate
      "
    >
      <svg-icon
        [src]="
          isFavorite
            ? `/assets/icons/fav-icon-filled-${providerWebsiteId}.svg`
            : `/assets/icons/fav-icon-${providerWebsiteId}.svg`
        "
        class="corner-actions__icon-wrapper"
        [svgClass]="'corner-actions__icon'"
      ></svg-icon>
    </button>
  </div>

  <div
    class="additional-info"
    [ngClass]="{
      'additional-info--with-logo': announcementDetails?.hasLogo
    }"
  >
    <div class="additional-info__date">
      <span
        [ngClass]="{
          'additional-info__date--istoday': announcementDetails.isPublishedToday
        }"
        >{{
          announcementDetails.isPublishedToday
            ? ('label.Today' | translate)
            : (publishDate | date: 'dd MMM':timeZone:currentLanguage)
        }}
        -
      </span>
      <span
        [ngClass]="{
          'additional-info__date--istoday': announcementDetails.isDeadLineToday
        }"
        >{{
          announcementDetails.isDeadLineToday
            ? ('label.Today' | translate)
            : (announcementDetails?.deadlineDate
              | date: 'dd MMM':timeZone:currentLanguage)
        }}</span
      >
      @if (isEditedVisible) {
      <span class="additional-info__date--edited"
        >{{ 'label.Edited' | translate }} -
      </span>
      <span
        [ngClass]="{
          'additional-info__date--istoday': announcementDetails.isEditedToday
        }"
        >{{
          announcementDetails.isEditedToday
            ? ('label.Today' | translate)
            : (announcementDetails?.moderationLastChangeDate
              | date: 'dd MMM':timeZone:currentLanguage)
        }}</span
      >
      }
    </div>
    <div class="additional-info__ann-type">
      {{
        listingSectionNameMap[announcementDetails?.listingSection] | translate
      }}
    </div>
  </div>

  <div class="tile-content">
    <div class="main-info">
      <div class="ann-title-container">
        <span class="ann-title-container__text">{{
          announcementDetails?.title
        }}</span>
        @if (announcementDetails?.isWorkFromHome) {
        <svg-icon
          title="{{ 'label.WorkFromHome' | translate }}"
          src="/assets/icons/home-green.svg"
          class="ann-title-container__icon"
          [svgClass]="'home-icon'"
        ></svg-icon>
        }
      </div>
      <div class="location">
        <hrra-announcement-location
          [locations]="announcementDetails?.extendedLocations"
        ></hrra-announcement-location>
      </div>
      <div
        *ngIf="announcementDetails?.isAnonymous; else elseBlock"
        class="company-name"
      >
        {{ announcementDetails?.customerName }}
      </div>

      <ng-template #elseBlock>
        <div class="company-name">
          <a
            [routerLink]="[
              '/customer',
              announcementDetails?.customerId,
              announcementDetails?.urlFriendlyCustomerName
            ]"
            class="company-name__link"
          >
            {{ announcementDetails?.customerName }}
          </a>
        </div>
      </ng-template>

      <div
        *ngIf="
          announcementDetails?.applicationMethod ===
          applicationMethod.EmailPhoneAddress
        "
        class="application application-email-phone-address"
      >
        <div class="application__text">
          {{ 'label.ApplicationInformation' | translate }}
        </div>
        <div
          *ngIf="announcementDetails?.applicationDetails.email"
          class="application__email"
        >
          <span>{{ 'label.Email' | translate }}: </span>
          <span>{{ announcementDetails?.applicationDetails.email }}</span>
        </div>
        <div
          *ngIf="announcementDetails?.applicationDetails.phoneNumber"
          class="application__phone"
        >
          <span>{{ 'label.Phone' | translate }}: </span>
          <span>{{ announcementDetails?.applicationDetails.phoneNumber }}</span>
        </div>
        <div
          *ngIf="announcementDetails?.applicationDetails.applicationAddress"
          class="application__address"
        >
          <span>{{ 'label.Address' | translate }}: </span>
          <span>{{
            announcementDetails?.applicationDetails.applicationAddress
          }}</span>
        </div>
      </div>

      <div *ngIf="announcementDetails?.hasAttachment" class="attachment">
        <a [href]="announcementDetails.attachmentUrl">
          <svg-icon
            class="attachment__icon"
            src="assets/icons/attachment-orange.svg"
            [svgClass]="'attachment-icon'"
          ></svg-icon>
          <span class="attachment__text">{{
            'label.Attachment' | translate
          }}</span>
        </a>
      </div>

      <!-- External apply (first): below the attachment (HR-3762). -->
      <a
        *ngIf="
          isPublicView &&
          currentUserType !== userType.Internal &&
          announcementDetails?.applicationMethod ==
            applicationMethod.RedirectToUrl
        "
        [ngClass]="{
          'customer-signed-in':
            isSignedIn && user?.userType == userType.customerAgent
        }"
        (click)="onExternalApply()"
        class="send-cv-btn application-url-btn external-apply--below-attachment"
        target="_blank"
      >
        <svg-icon src="/assets/icons/send-cv-external.svg"></svg-icon>
        <div class="external-apply-label">
          <span class="apply-label">{{ 'label.Apply' | translate }}</span>
          <span class="send-cv-btn__text-other-website">
            {{ 'label.ExternalApply' | translate }}</span
          >
        </div>
      </a>
    </div>

    <div class="buttons-area">
    @if (isBrowser && isJobseekerInvited) {
    <div class="invite-response">
      <div class="invite-response__text">
        {{
          (isInviteEditMode
            ? 'label.ChangeStatus'
            : isInviteStatusChosen
            ? 'label.ChosenStatus'
            : 'label.YouAreInvitedToThisVacancy'
          ) | translate
        }}
      </div>
      @if(isInviteStatusChosen){
      <div class="invite-response__chosen">
        <div
          class="invite-response__btn invite-response__btn--chosen"
          [ngClass]="
            'invite-response__btn--chosen-' +
            inviteResponseModifierMap[
              announcementInvitedJobseeker.responseStatus
            ]
          "
        >
          {{
            inviteResponseLabelMap[announcementInvitedJobseeker.responseStatus]
              | translate
          }}
        </div>
        @if(canEditInviteResponse){
        <button class="invite-response__edit" (click)="onEnableInviteEdit()">
          <svg-icon
            class="invite-response__edit-icon"
            src="/assets/icons/edit-pencil.svg"
          ></svg-icon>
          <span class="invite-response__edit-text">{{
            'label.YouCanChangeInvitationStatusOnce' | translate
          }}</span>
        </button>
        }
      </div>
      } @else {
      @if( announcementDetails?.applicationMethod ==
      applicationMethod.ViaWebsite && ((isJobseekerSignedIn &&
      !announcementDetails?.isBeenApplied) || !isJobseekerSignedIn) ){
      <button
        class="invite-response__btn invite-response__btn--interested-and-apply"
        [ngClass]="{
          'invite-response__btn--selected':
            announcementInvitedJobseeker.responseStatus === inviteResponse.InterestedAndApplied
        }"
        [disabled]="isInviteOptionDisabled(inviteResponse.InterestedAndApplied)"
        (click)="onInviteRespond(inviteResponse.InterestedAndApplied)"
      >
        {{ 'label.InvitationStatusInterestedAndApply' | translate }}
      </button>
      }
      <button
        class="invite-response__btn invite-response__btn--interested"
        [ngClass]="{
          'invite-response__btn--selected':
            announcementInvitedJobseeker.responseStatus === inviteResponse.Interested
        }"
        [disabled]="isInviteOptionDisabled(inviteResponse.Interested)"
        (click)="onInviteRespond(inviteResponse.Interested)"
      >
        {{ 'label.InvitationStatusInterested' | translate }}
      </button>
      <button
        class="invite-response__btn invite-response__btn--not-interested"
        [ngClass]="{
          'invite-response__btn--selected':
            announcementInvitedJobseeker.responseStatus === inviteResponse.NotInterested
        }"
        [disabled]="isInviteOptionDisabled(inviteResponse.NotInterested)"
        (click)="onInviteRespond(inviteResponse.NotInterested)"
      >
        {{ 'label.InvitationStatusNotInterested' | translate }}
      </button>
      }
    </div>
    } @else if(isBrowser && !isJobseekerInvited){
    <div class="buttons">
      <div class="send-cv" *ngIf="currentUserType !== userType.Internal">
        <button
          *ngIf="
            announcementDetails?.applicationMethod ==
              applicationMethod.ViaWebsite &&
            ((isJobseekerSignedIn && !announcementDetails?.isBeenApplied) ||
              !isJobseekerSignedIn)
          "
          [ngClass]="{
            'customer-signed-in':
              isSignedIn && user?.userType == userType.customerAgent
          }"
          class="send-cv-btn send-cv-button-ats"
          (click)="onCvSend()"
        >
          <svg-icon src="/assets/icons/send-cv-ats.svg"></svg-icon>
          {{ 'label.EasyApply' | translate }}
        </button>
        <div
          *ngIf="
            !showInviteResponse &&
            isJobseekerSignedIn &&
            announcementDetails?.isBeenApplied
          "
          class="cv-sent-btn"
        >
          {{ 'label.CvSent' | translate }}
        </div>
      </div>
    </div>
    }

    </div>

    <div
      class="send-cv-btn--mobile send-cv"
      *ngIf="
        currentUserType !== userType.Internal &&
        announcementDetails?.applicationMethod == applicationMethod.ViaWebsite
      "
    >
      <button
        *ngIf="
          !showInviteResponse &&
          announcementDetails?.applicationMethod ==
            applicationMethod.ViaWebsite &&
          ((isJobseekerSignedIn && !announcementDetails?.isBeenApplied) ||
            !isJobseekerSignedIn)
        "
        [ngClass]="{
          'customer-signed-in':
            isSignedIn && user?.userType == userType.customerAgent
        }"
        class="send-cv-btn send-cv-button-ats"
        (click)="onCvSend()"
      >
        <svg-icon src="/assets/icons/send-cv-ats.svg"></svg-icon>
        {{ 'label.EasyApply' | translate }}
      </button>
      <div
        *ngIf="
          !showInviteResponse &&
          isJobseekerSignedIn &&
          announcementDetails?.isBeenApplied
        "
        class="cv-sent-btn"
      >
        {{ 'label.CvSent' | translate }}
      </div>
    </div>

    <div class="details-and-requirements">
      <div class="details-container">
        <h3 class="vacant-position-details-header">
          {{ 'label.InformationAboutVacantPosition' | translate }}:
        </h3>
        <div class="details" #announcementRequirements>
          <ul class="list">
            <li
              *ngIf="
                announcementDetails?.announcementRequirements.specializationList
                  .length
              "
            >
              <div class="announcement-details-industry">
                <span class="industry-label"
                  >{{ 'label.SpecializationPosition' | translate }}:
                </span>
                <span
                  class="industries-main-container"
                  *ngFor="
                    let specialization of announcementDetails
                      ?.announcementRequirements.specializationList
                  "
                >
                  <span class="industries-main">{{ specialization.name }}</span>
                  <svg-icon
                    class="categories__icon"
                    src="/assets/icons/chevron-right-blue.svg"
                  >
                  </svg-icon>
                  <span
                    class="subindustries"
                    *ngFor="
                      let childSpecialization of specialization.children;
                      let last = last
                    "
                  >
                    {{
                      last
                        ? childSpecialization.name + ''
                        : childSpecialization.name + ','
                    }}
                  </span>
                </span>
              </div>
            </li>
            <li
              *ngIf="
                announcementDetails?.announcementRequirements.industryList
                  .length
              "
            >
              <div class="announcement-details-industry">
                <span class="industry-label"
                  >{{ 'label.IndustryField' | translate }}:
                </span>
                <span
                  class="industries-main-container"
                  *ngFor="
                    let industry of announcementDetails
                      ?.announcementRequirements.industryList
                  "
                >
                  <span class="industries-main">{{ industry.name }}</span>
                  <svg-icon
                    class="categories__icon"
                    src="/assets/icons/chevron-right-blue.svg"
                  >
                  </svg-icon>
                  <span
                    class="subindustries"
                    *ngFor="
                      let childIndustry of industry.children;
                      let last = last
                    "
                  >
                    {{
                      last ? childIndustry.name + '' : childIndustry.name + ','
                    }}
                  </span>
                </span>
              </div>
            </li>
            <li
              *ngIf="
                announcementDetails?.announcementRequirements.seniorityLevels
                  .length
              "
              class="list__item"
            >
              <span class="bold-label list-item-label">
                {{ 'label.SeniorityLevel' | translate }}:
              </span>
              <span>{{
                announcementDetails?.announcementRequirements.seniorityLevels
              }}</span>
            </li>

            <!-- work schedule -->
            <li
              class="list__item"
              *ngIf="
                announcementDetails?.announcementRequirements?.workScheduleName
              "
            >
              <span class="bold-label list-item-label">
                {{ 'label.ScheduleType' | translate }}:
              </span>
              <span>{{
                announcementDetails?.announcementRequirements?.workScheduleName
              }}</span>
            </li>

            <!--new employment form type -->
            <li
              class="list__item"
              *ngIf="
                announcementDetails?.announcementRequirements
                  ?.employmentTypeName
              "
            >
              <span class="bold-label list-item-label">
                {{ 'label.EmploymentForm' | translate }}:
              </span>
              <span>{{
                announcementDetails?.announcementRequirements
                  ?.employmentTypeName
              }}</span>
            </li>

            <!-- business trip -->
            <li
              class="list__item"
              *ngIf="
                announcementDetails?.announcementRequirements
                  ?.travelRequirements?.isTravelRequired
              "
            >
              <span class="bold-label list-item-label">
                {{ 'label.BusinessTrip' | translate }}:
              </span>
              <span
                >{{
                  announcementDetails?.announcementRequirements
                    ?.travelRequirements?.isTravelRequired
                    ? ('label.Yes' | translate)
                    : ('label.No' | translate)
                }}{{
                  announcementDetails?.announcementRequirements
                    ?.travelRequirements.travelPercentage
                    ? '(' +
                      announcementDetails?.announcementRequirements
                        ?.travelRequirements.travelPercentage +
                      '%) '
                    : ''
                }}{{
                  announcementDetails?.announcementRequirements
                    ?.travelRequirements.isTravelAbroad &&
                  announcementDetails?.announcementRequirements
                    ?.travelRequirements.isTravelDomestic
                    ? '(' +
                      ('label.Domestic' | translate) +
                      '+' +
                      ('label.Abroad' | translate) +
                      ')'
                    : announcementDetails?.announcementRequirements
                        ?.travelRequirements.isTravelAbroad &&
                      !announcementDetails?.announcementRequirements
                        ?.travelRequirements.isTravelDomestic
                    ? '(' + ('label.Abroad' | translate) + ')'
                    : !announcementDetails?.announcementRequirements
                        ?.travelRequirements.isTravelAbroad &&
                      announcementDetails?.announcementRequirements
                        ?.travelRequirements.isTravelDomestic
                    ? '(' + ('label.Domestic' | translate) + ')'
                    : ''
                }}</span
              >
            </li>

            <!-- employment form -->
            <li
              *ngIf="
                announcementDetails?.type === announcementType.Vacancy ||
                announcementDetails?.type === announcementType.Other
              "
              class="list__item"
            >
              <span class="bold-label list-item-label">
                {{ 'label.WorkLocation' | translate }}:
              </span>
              <span>{{ announcementDetails?.employmentFormTypeName }}</span>
            </li>

            <li *ngIf="announcementDetails?.businessTravel" class="list__item">
              <span class="bold-label"
                >{{ 'label.BusinessTrip' | translate }}:
              </span>
              <span>{{ 'label.BusinessTravel' | translate }}</span>
            </li>
            <li
              *ngIf="
                (announcementDetails?.salaryFrom !== null ||
                  announcementDetails?.salaryTo !== null ||
                  announcementDetails?.bonusFrom !== null ||
                  announcementDetails?.bonusTo !== null ||
                  announcementDetails?.isWithBonus !== false) &&
                (!announcementDetails?.hideSalary ||
                  announcementDetails?.hideSalary === null)
              "
              class="list__item salary-description"
            >
              <span class="bold-label list-item-label">
                {{ 'label.Salary' | translate }}:
              </span>
              <div
                *ngIf="
                  announcementDetails?.salaryFrom ||
                  announcementDetails?.salaryTo
                "
                class="fixed"
              >
                <span>{{ 'label.Fixed' | translate }} </span>
                <span>{{ announcementDetails?.salaryFrom }}</span>
                <span *ngIf="announcementDetails?.salaryTo != null">
                  - {{ announcementDetails?.salaryTo }}</span
                >
                <span
                  *ngIf="
                    announcementDetails?.salaryFrom != null ||
                    announcementDetails?.salaryTo != null
                  "
                >
                </span>
              </div>
              <span class="bonus">
                <span
                  *ngIf="
                    announcementDetails?.bonusFrom == null &&
                    announcementDetails?.bonusTo == null &&
                    announcementDetails?.isWithBonus
                  "
                >
                  (+ {{ 'label.Bonus' | translate }})
                </span>
                <span
                  *ngIf="
                    (announcementDetails?.bonusFrom ||
                      announcementDetails?.bonusTo) &&
                    announcementDetails?.isWithBonus
                  "
                >
                  (+ {{ 'label.Bonus' | translate }}
                </span>
                <span
                  *ngIf="
                    announcementDetails?.bonusFrom &&
                    announcementDetails?.isWithBonus
                  "
                >
                  {{ announcementDetails?.bonusFrom }}
                </span>
                <span
                  *ngIf="
                    announcementDetails?.bonusFrom !== null &&
                    announcementDetails?.bonusTo !== null &&
                    announcementDetails?.isWithBonus
                  "
                >
                  -
                </span>
                <span
                  *ngIf="
                    announcementDetails?.bonusTo &&
                    announcementDetails?.isWithBonus
                  "
                >
                  {{ announcementDetails?.bonusTo }}
                </span>
                <!-- <span
                  *ngIf="
                    announcementDetails?.bonusFrom !== null ||
                    announcementDetails?.bonusTo !== null
                  "
                >
                </span> -->
                <span
                  *ngIf="
                    (announcementDetails?.bonusFrom ||
                      announcementDetails?.bonusTo) &&
                    announcementDetails?.isWithBonus
                  "
                  >)
                </span>
              </span>
            </li>
            <li
              *ngIf="announcementDetails?.benefits?.length > 0"
              class="list__item"
            >
              <span class="bold-label list-item-label"
                >{{ 'label.AdditionalBenefits' | translate }}:
              </span>
              <span
                *ngFor="
                  let benefit of announcementDetails?.benefits;
                  let last = last
                "
                >{{ last ? benefit + '' : benefit + ',' }}</span
              >
            </li>
          </ul>
        </div>
      </div>

      <div
        class="requirements-container"
        *ngIf="announcementDetails?.type === announcementType.Vacancy"
      >
        <h3 class="vacant-position-requirements-header">
          {{ 'label.EmployerRequirement' | translate }}:
        </h3>
        <div class="requirements" #employerRequirements>
          <ul class="list">
            <li
              *ngIf="announcementDetails?.workExperienceType !== null"
              class="list__item"
            >
              <span class="bold-label list-item-label"
                >{{
                  announcementDetails?.workExperienceType ===
                    workExperienceTypeEnum.WithExperience ||
                  announcementDetails?.workExperienceType ===
                    workExperienceTypeEnum.WithoutExperience
                    ? ('label.WorkExperience' | translate)
                    : announcementDetails?.employerRequirements
                        .isWorkExperienceYearsMandatory
                    ? ('label.MandatoryExperience' | translate)
                    : ('label.DesiredExperience' | translate)
                }}:
              </span>

              <span class="type">{{
                announcementWorkExperienceEnumMap[
                  announcementDetails.workExperienceType
                ] | translate
              }}</span>
              <span
                *ngIf="
                  announcementDetails?.workExperienceFrom !== null &&
                  announcementDetails?.workExperienceTo !== null
                "
              >
                {{
                  'text.ExperienceYears'
                    | translate
                      : {
                          count: announcementDetails?.workExperienceTo,
                          fromyears: announcementDetails?.workExperienceFrom,
                          toyears: announcementDetails?.workExperienceTo
                        }
                }}
              </span>
              <span
                *ngIf="
                  announcementDetails?.workExperienceFrom !== null &&
                  announcementDetails?.workExperienceTo === null
                "
              >
                {{ 'label.ExperienceYears' | translate }}
                {{
                  'text.ExperienceFromYears'
                    | translate
                      : {
                          count: announcementDetails?.workExperienceFrom,
                          fromyears: announcementDetails?.workExperienceFrom
                        }
                }}
              </span>
              <span
                *ngIf="
                  announcementDetails?.workExperienceTo !== null &&
                  announcementDetails?.workExperienceFrom === null
                "
              >
                {{ 'label.ExperienceYears' | translate }}
                {{
                  'text.ExperienceToYears'
                    | translate
                      : {
                          count: announcementDetails?.workExperienceTo,
                          toyears: announcementDetails?.workExperienceTo
                        }
                }}
              </span>
            </li>
            <li
              *ngIf="
                announcementDetails?.workExperienceType ===
                  workExperienceTypeEnum.Mandatory &&
                !announcementDetails?.employerRequirements
                  .isSpecializationIgnored
              "
            >
              <div
                class="announcement-details-industry"
                *ngIf="
                  announcementDetails?.employerRequirements.specializationList
                    .length
                "
              >
                <span class="industry-label bold-label"
                  >{{
                    ('label.SpecializationPosition' | translate) +
                      '(' +
                      ((announcementDetails?.employerRequirements
                        .isSpecializationMandatory
                        ? 'label.Mandatory'
                        : 'label.Desired'
                      ) | translate) +
                      ')'
                  }}:
                </span>
                <div
                  class="industries-main-container"
                  *ngFor="
                    let specialization of announcementDetails
                      ?.employerRequirements.specializationList
                  "
                >
                  <span class="industries-main">{{ specialization.name }}</span>
                  <svg-icon
                    class="categories__icon"
                    src="/assets/icons/chevron-right-blue.svg"
                  >
                  </svg-icon>
                  <span
                    class="subindustries"
                    *ngFor="
                      let childIndustry of specialization.children;
                      let last = last
                    "
                  >
                    {{
                      last ? childIndustry.name + '' : childIndustry.name + ','
                    }}
                  </span>
                </div>
              </div>
            </li>
            <li
              *ngIf="
                announcementDetails?.employerRequirements.industryList.length &&
                announcementDetails?.workExperienceType ===
                  workExperienceTypeEnum.Mandatory &&
                !announcementDetails?.employerRequirements.isIndustryIgnored
              "
            >
              <div class="announcement-details-industry">
                <span class="industry-label bold-label"
                  >{{
                    ('label.IndustryField' | translate) +
                      '(' +
                      ((announcementDetails?.employerRequirements
                        .isIndustryMandatory
                        ? 'label.Mandatory'
                        : 'label.Desired'
                      ) | translate) +
                      ')'
                  }}:
                </span>
                <div
                  class="industries-main-container"
                  *ngFor="
                    let industry of announcementDetails?.employerRequirements
                      .industryList
                  "
                >
                  <span class="industries-main">{{ industry.name }}</span>
                  <svg-icon
                    class="categories__icon"
                    src="/assets/icons/chevron-right-blue.svg"
                  >
                  </svg-icon>
                  <span
                    class="subindustries"
                    *ngFor="
                      let childIndustry of industry.children;
                      let last = last
                    "
                  >
                    {{
                      last ? childIndustry.name + '' : childIndustry.name + ','
                    }}
                  </span>
                </div>
              </div>
            </li>
            <li
              *ngIf="
                announcementDetails?.employerRequirements.seniorityLevels
                  .length &&
                announcementDetails?.workExperienceType ===
                  workExperienceTypeEnum.Mandatory
              "
              class="list__item"
            >
              <span class="bold-label list-item-label">
                {{ 'label.SeniorityLevel' | translate }}:
              </span>
              <span
                *ngFor="
                  let seniorityLevel of announcementDetails
                    ?.employerRequirements.seniorityLevels;
                  let last = last
                "
                >{{ last ? seniorityLevel : seniorityLevel + ',' }}</span
              >
            </li>

            <li
              *ngIf="
                announcementDetails?.employerRequirements.educationLevels.length
              "
              class="list__item"
            >
              <span class="bold-label list-item-label"
                >{{ 'label.AnnouncementEducationLevel' | translate }}:
              </span>
              <span
                *ngFor="
                  let educationLevel of announcementDetails
                    ?.employerRequirements.educationLevels;
                  let last = last
                "
                >{{ last ? educationLevel : educationLevel + ', ' }}</span
              >
            </li>

            <li
              *ngIf="
                announcementDetails?.employerRequirements.educationPrograms
                  .length
              "
              class="list__item"
            >
              <span class="bold-label list-item-label"
                >{{ 'label.EducationPrograms' | translate }}:
              </span>
              <span
                *ngFor="
                  let educationProgram of announcementDetails
                    ?.employerRequirements.educationPrograms;
                  let last = last
                "
                >{{ last ? educationProgram : educationProgram + ', ' }}</span
              >
            </li>

            <li
              class="list__item"
              *ngIf="announcementDetails?.isSuitableForStudent"
            >
              <span class="bold-label list-item-label"
                >{{ 'label.SuitableForStudents' | translate }}:
              </span>
              <span>
                {{ 'label.Yes' | translate }}
              </span>
            </li>

            <li
              *ngIf="announcementDetails?.languages.length > 0"
              class="list__item language"
            >
              <span class="bold-label list-item-label"
                >{{ 'label.Languages' | translate }}:
              </span>
              <span
                *ngFor="
                  let language of announcementDetails?.languages;
                  let last = last;
                  let first = first
                "
                class="language__item"
              >
                <span>{{ language }}{{ last ? '' : ',' }}</span>
              </span>
            </li>

            <!-- technical (hard) skills -->
            @if (announcementDetails?.employerRequirements?.hardSkills?.length) {
            <li class="list__item">
              <span class="bold-label list-item-label"
                >{{ 'label.HardSkills' | translate }}:
              </span>
              @for (skill of announcementDetails?.employerRequirements?.hardSkills;
              track skill.index; let last = $last) {
              <span>{{
                (skill.name ? skill.name : skill.userProvidedText) +
                  (last ? '' : '; ')
              }}</span>
              }
            </li>
            }

            @if (announcementDetails?.employerRequirements?.softSkills?.length) {
            <li class="list__item">
              <span class="bold-label list-item-label"
                >{{ 'label.SoftSkills' | translate }}:
              </span>
              @for (skill of announcementDetails?.employerRequirements?.softSkills;
              track skill.index; let last = $last) {
              <span>{{
                (skill.name ? skill.name : skill.userProvidedText) +
                  (last ? '' : '; ')
              }}</span>
              }
            </li>
            }
            <li
              *ngIf="announcementDetails?.drivingLicenses.length > 0"
              class="list__item driving-license"
            >
              <span class="driving-license__text bold-label"
                >{{ 'label.DrivingLicence' | translate }}:
              </span>
              <span
                *ngFor="
                  let drivingLicense of announcementDetails?.drivingLicenses;
                  let last = last;
                  let first = first
                "
                class="driving-license__item"
              >
                <span
                  >{{ drivingLicense + ' ' + ('label.Category' | translate) }}
                  {{ last ? '' : ',' }}</span
                >
              </span>
            </li>

            <li
              *ngIf="
                announcementDetails?.drivingLicenses.length > 0 &&
                announcementDetails?.employerRequirements.hasTransport &&
                announcementDetails?.employerRequirements.transportTypes
              "
              class="list__item driving-license"
            >
              <span class="bold-label list-item-label"
                >{{ 'label.OwnTransport' | translate }}:</span
              >
              <span>{{ 'label.Yes' | translate }}</span>
              <span
                *ngFor="
                  let transport of announcementDetails?.employerRequirements
                    .transportTypes;
                  let last = last;
                  let first = first
                "
                class="driving-license__item"
              >
                {{
                  first && last
                    ? '(' + transport + ')'
                    : last
                    ? transport + ')'
                    : first
                    ? '(' + transport + ','
                    : transport + ','
                }}
              </span>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div
      #descriptionContainer
      class="description"
      [innerHTML]="announcementDetails?.description | safeHtml"
    ></div>
  </div>

  <!-- External apply (second): below all content, start-aligned, always visible. -->
  <a
    *ngIf="
      isPublicView &&
      currentUserType !== userType.Internal &&
      announcementDetails?.applicationMethod === applicationMethod.RedirectToUrl
    "
    [ngClass]="{
      'customer-signed-in':
        isSignedIn && user?.userType === userType.customerAgent,
    }"
    (click)="onExternalApply()"
    class="send-cv-btn application-url-btn external-apply--bottom"
    target="_blank"
  >
    <svg-icon src="/assets/icons/send-cv-external.svg"></svg-icon>
    <div class="external-apply-label">
      <span class="apply-label">{{ 'label.Apply' | translate }}</span>
      <span class="send-cv-btn__text-other-website">
        {{ 'label.ExternalApply' | translate }}</span
      >
    </div>
  </a>
  @if(isBrowser && !isJobseekerInvited){
   <div
     class="buttons-bottom"
   >
    <div class="send-cv" *ngIf="currentUserType !== userType.Internal">
      <button
        *ngIf="
          !showInviteResponse &&
          announcementDetails?.applicationMethod ==
            applicationMethod.ViaWebsite &&
          ((isJobseekerSignedIn && !announcementDetails?.isBeenApplied) ||
            !isJobseekerSignedIn)
        "
        [ngClass]="{
          'customer-signed-in':
            isSignedIn && user?.userType == userType.customerAgent
        }"
        class="send-cv-btn send-cv-button-ats"
        (click)="onCvSend()"
      >
        <svg-icon src="/assets/icons/send-cv-ats.svg"></svg-icon>
        {{ 'label.EasyApply' | translate }}
      </button>
      <div
        *ngIf="
          !showInviteResponse &&
          isJobseekerSignedIn &&
          announcementDetails?.isBeenApplied
        "
        class="cv-sent-btn"
      >
        {{ 'label.CvSent' | translate }}
      </div>
    </div>
  </div>
  }
  @else if(isBrowser && isJobseekerInvited){  <div class="invite-response-bottom">
    <div class="invite-response-bottom__text">
      {{
        (isInviteEditMode
          ? 'label.ChangeStatus'
          : isInviteStatusChosen
          ? 'label.ChosenStatus'
          : 'label.YouAreInvitedToThisVacancy'
        ) | translate
      }}
    </div>
    @if(isInviteStatusChosen){
    <div class="invite-response-bottom__chosen">
      <div
        class="invite-response-bottom__btn invite-response-bottom__btn--chosen"
        [ngClass]="
          'invite-response-bottom__btn--chosen-' +
          inviteResponseModifierMap[announcementInvitedJobseeker.responseStatus]
        "
      >
        {{
          inviteResponseLabelMap[announcementInvitedJobseeker.responseStatus]
            | translate
        }}
      </div>
      @if(canEditInviteResponse){
      <button
        class="invite-response-bottom__edit"
        (click)="onEnableInviteEdit()"
      >
        <svg-icon
          class="invite-response-bottom__edit-icon"
          src="/assets/icons/edit-pencil.svg"
        ></svg-icon>
        <span class="invite-response-bottom__edit-text">{{
          'label.YouCanChangeInvitationStatusOnce' | translate
        }}</span>
      </button>
      }
    </div>
    } @else {
    @if( announcementDetails?.applicationMethod == applicationMethod.ViaWebsite
    && ((isJobseekerSignedIn && !announcementDetails?.isBeenApplied) ||
    !isJobseekerSignedIn) ){
    <button
      class="invite-response-bottom__btn invite-response-bottom__btn--interested-and-apply"
      [ngClass]="{
        'invite-response-bottom__btn--selected':
          announcementInvitedJobseeker.responseStatus === inviteResponse.InterestedAndApplied
      }"
      [disabled]="isInviteOptionDisabled(inviteResponse.InterestedAndApplied)"
      (click)="onInviteRespond(inviteResponse.InterestedAndApplied)"
    >
      {{ 'label.InvitationStatusInterestedAndApply' | translate }}
    </button>
    }
    <button
      class="invite-response-bottom__btn invite-response-bottom__btn--interested"
      [ngClass]="{
        'invite-response-bottom__btn--selected':
          announcementInvitedJobseeker.responseStatus === inviteResponse.Interested
      }"
      [disabled]="isInviteOptionDisabled(inviteResponse.Interested)"
      (click)="onInviteRespond(inviteResponse.Interested)"
    >
      {{ 'label.InvitationStatusInterested' | translate }}
    </button>
    <button
      class="invite-response-bottom__btn invite-response-bottom__btn--not-interested"
      [ngClass]="{
        'invite-response-bottom__btn--selected':
          announcementInvitedJobseeker.responseStatus === inviteResponse.NotInterested
      }"
      [disabled]="isInviteOptionDisabled(inviteResponse.NotInterested)"
      (click)="onInviteRespond(inviteResponse.NotInterested)"
    >
      {{ 'label.InvitationStatusNotInterested' | translate }}
    </button>
    }
  </div>
}

</div>
